// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"221ad720","551":"45033eb5","632":"7800ab40","773":"09fa6ec9"}[chunkId] + ".chunk.js";
};